(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rotating-image"] && !Shopify.designMode) return;
  try {
    class RotatingImageBlock extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rotating-image-block__slide'));
      if (this.slides.length < 2) return;

      this.activeIndex = 0;
      this.slides[0].classList.add('is-active');
      this.setAttribute('data-initialized', '');

      this.interval = parseInt(this.dataset.interval, 10) || 10000;
      this.startTimer();

      this.addEventListener('click', () => {
        this.showNext();
        this.startTimer();
      });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.showNext(), this.interval);
    }

    showNext() {
      const current = this.slides[this.activeIndex];
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      const next = this.slides[this.activeIndex];
      current.classList.remove('is-active');
      next.classList.add('is-active');
    }
  }

  if (!customElements.get('rotating-image-block')) {
    customElements.define('rotating-image-block', RotatingImageBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
